import React, { useRef, useState } from "react";
import SingleFundraiserComponent from "./SingleFundraiser";
import "./FundraiserList.css"; // Import styles
import { AccountProfileFundraisers } from "../../../Interfaces/Fundraiser";
import { FundraiserType } from "../../../Interfaces/FundraiserRole";

interface FundraiserListProps {
  fundraisers: AccountProfileFundraisers[];
  fundraiserStatus: string;
  fundraiserType: FundraiserType;
}

const FundraiserList: React.FC<FundraiserListProps> = ({
  fundraisers,
  fundraiserStatus,
  fundraiserType,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [scrollIndex, setScrollIndex] = useState(0);
  const cardsPerView = window.innerWidth > 1200 ? 3 : window.innerWidth > 768 ? 2 : 1;
  const maxScrollIndex = Math.ceil(fundraisers.length / cardsPerView) - 1;

  const handleScroll = (direction: string) => {
    if (scrollRef.current) {
      const cardWidth = scrollRef.current.firstChild
        ? (scrollRef.current.firstChild as HTMLDivElement).clientWidth
        : 0;
      const scrollAmount = cardWidth * cardsPerView;

      if (direction === "left" && scrollIndex > 0) {
        setScrollIndex((prev) => prev - 1);
        scrollRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      } else if (direction === "right" && scrollIndex < maxScrollIndex) {
        setScrollIndex((prev) => prev + 1);
        scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    }
  };

  return (
    <div className="user-profile-fundraiser-list-container">
      <h2 className="user-profile-fundraiser-list-status">
        {fundraiserStatus}
      </h2>
      {fundraisers.length === 0 ? (
        <p className="no-fundraisers-message">
          No fundraisers found for this category.
        </p>
      ) : (
        <div className="user-profile-fundraiser-list-wrapper">
          {scrollIndex > 0 && (
            <button
              className="user-profile-fundraiser-list-scroll-button left"
              onClick={() => handleScroll("left")}
            >
              {"<"}
            </button>
          )}
          <div className="user-profile-fundraiser-list" ref={scrollRef}>
            {fundraisers.map((fundraiser) => (
              <div
                className="user-profile-fundraiser-list-card"
                key={fundraiser.fundraiser.id}
              >
                <SingleFundraiserComponent
                  campaignName={`${fundraiser.fundraiser.org_name}: ${fundraiser.fundraiser.fundraiser_name}`}
                  goalAmount={fundraiser.fundraiser.goal}
                  raisedAmount={fundraiser.fundraiser.fundraiser_total_money}
                  fundraiserType={fundraiserType}
                  linkExtension={
                    fundraiserType === "coord" || fundraiserType === "teamAdmin"
                      ? fundraiser.fundraiser.id.toString()
                      : fundraiser.participant_code || "" 
                  }
                />
              </div>
            ))}
          </div>
          {scrollIndex < maxScrollIndex && (
            <button
              className="user-profile-fundraiser-list-scroll-button right"
              onClick={() => handleScroll("right")}
            >
              {">"}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default FundraiserList;
